import { render, staticRenderFns } from "./collectionAccountReviewModal.vue?vue&type=template&id=4e6ae6ad&scoped=true"
import script from "./collectionAccountReviewModal.vue?vue&type=script&lang=js"
export * from "./collectionAccountReviewModal.vue?vue&type=script&lang=js"
import style0 from "./collectionAccountReviewModal.vue?vue&type=style&index=0&id=4e6ae6ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6ae6ad",
  null
  
)

export default component.exports